import React from 'react';
import BlogCard from '@/components/blog/BlogCard';
import { blogPosts } from '@/lib/blogData';
import { Badge } from '@/components/ui/badge';
import SEO from '@/components/seo/SEO';
import { NewsletterCTA } from '@/components/blog/index/NewsletterCTA';

const BlogIndexPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#f8f5ef] font-sans">
      <SEO
        title="LendLifted Insights"
        description="Actionable playbooks for financing-enabled checkout, close-rate growth, and follow-up strategy for small sellers."
        canonical="/blog"
      />

      <div className="container px-6 pb-20 pt-32 text-center">
        <Badge variant="outline" className="mb-6 rounded-full border-slate-200 px-4 py-1.5 text-sm font-medium text-slate-600">
          Insights
        </Badge>
        <h1 className="mb-6 text-5xl font-extrabold tracking-tight text-slate-950 md:text-7xl">
          Financing insights for
          <br className="hidden md:block" />
          growth-minded sellers.
        </h1>
        <p className="mx-auto max-w-2xl text-xl leading-relaxed text-slate-600">
          Practical guides on quote flow, payment messaging, and follow-up strategy that helps more buyers say yes.
        </p>
      </div>

      <div className="container px-6 pb-32">
        {blogPosts.length > 0 ? (
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3 lg:gap-10">
            {blogPosts.map((post) => (
              <BlogCard key={post.slug} {...post} />
            ))}
          </div>
        ) : (
          <div className="rounded-[2rem] border border-slate-200 bg-slate-50 py-32 text-center">
            <p className="text-lg text-slate-500">No posts yet. Check back soon for new seller growth playbooks.</p>
          </div>
        )}
      </div>

      <NewsletterCTA />
    </div>
  );
};

export default BlogIndexPage;
